import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="legal-container">
      <h1>Terms & Conditions</h1>
      <p><strong>Last Updated:</strong> [02/03/2026]</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing Traki, you agree to these terms.
      </p>

      <h2>2. Membership Access</h2>
      <ul>
        <li>Membership is valid for selected duration only.</li>
        <li>Account sharing is strictly prohibited.</li>
        <li>Access expires after membership period ends.</li>
      </ul>

      <h2>3. Manual Renewal Policy</h2>
      <p>
        Membership does not auto-renew. Users must manually renew
        before expiry to continue services.
      </p>

      <h2>4. Payment Terms</h2>
      <p>
        Full payment is required before activation.
      </p>

      <h2>5. Account Suspension</h2>
      <p>
        We reserve the right to suspend accounts for misuse or fraud.
      </p>

      <h2>6. Governing Law</h2>
      <p>These terms are governed by the laws of India.</p>
    </div>
  );
};

export default TermsAndConditions;